export default {
  getPerson: (state) => (id) => {
    return state.persons.length > 0 ? state.persons.items.find(person => person.id === id): {}
  },
}
